import { MapPin } from "lucide-react";

type ServiceAreaDisplayProps = {
  displayText: string;
  hasMore: boolean;
  remainingCounties?: string[];
  showTooltip: boolean;
  onTooltipEnter: () => void;
  onTooltipLeave: () => void;
};

export const ServiceAreaDisplay = ({
  displayText,
  hasMore,
  remainingCounties,
  showTooltip,
  onTooltipEnter,
  onTooltipLeave,
}: ServiceAreaDisplayProps) => {
  return (
    <div className="flex flex-col items-end text-right text-[#111827] shrink-0 lg:pt-0">
      <div className="flex items-center pb-2">
        <MapPin className="h-7 w-7 shrink-0 text-[#026857]" />
        <span className="text-[16px] font-termina capitalize text-[#111827] ml-2">
          Service Area
        </span>
      </div>
      <div className="flex flex-wrap items-center gap-1.5 text-sm font-termina text-[#4B5563] justify-end">
        <span>{displayText}</span>
        {hasMore && (
          <div
            className="relative inline-block"
            onMouseEnter={onTooltipEnter}
            onMouseLeave={onTooltipLeave}
          >
            <span className="text-xs font-termina font-medium cursor-pointer text-[#026857] hover:text-[#025247] transition-colors">
              +{remainingCounties?.length || 0}
            </span>
            {showTooltip &&
              remainingCounties &&
              remainingCounties.length > 0 && (
                <div className="absolute right-0 bottom-full mb-2 w-64 rounded-xl border border-[#E5E7EB] bg-white p-3 shadow-xl z-10">
                  <p className="text-xs font-termina font-semibold text-[#111827] mb-2 uppercase tracking-wide">
                    Remaining Counties ({remainingCounties.length})
                  </p>
                  <div className="flex flex-wrap gap-1.5">
                    {remainingCounties.map((county, index) => (
                      <span
                        key={index}
                        className="inline-block px-2 py-1 rounded-md bg-[#F3F4F6] text-sm font-termina text-[#4B5563]"
                      >
                        {county}
                      </span>
                    ))}
                  </div>
                </div>
              )}
          </div>
        )}
      </div>
    </div>
  );
};

